export const camera = {
  title: 'Kamera',
  resetDefaultCamera: 'Wróć do klasycznej kamery',
  addNewCamera: 'Dodaj nowy widok kamery',
  addCamera: 'Dodaj kamerę',
  addLocalCamera: 'Dodaj lokalną kamerę',
  addGlobalCamera: 'Dodaj globalną kamerę',
  createdCamera: 'Utworzono kamerę',
  newCameraNotSaved: 'Istnieje nowo utworzona, jeszcze nie zapiasna kamera',
  editCameraSettings: 'Edytuj ustawienia',
  cancelCameraSettings: 'Anuluj edycję',
  removeCamera: 'Usuń kamerę',
  removeGlobalCamera: 'Usuń globalną kamerę',
  removedCamera: 'Usunięto kamerę',
  savedChanges: 'Zapisano zmiany',
  saveCameraSettings: 'Zapisz zmiany',
  viewCamera: 'Podgląd kamery',
  viewCameraTooltip: 'Podgląd kamery',
  editCameraTooltip: 'Edycja kamery',
  newCameraTitle: 'Nowa kamera',
  editCameraTitle: 'Edycja kamery',
  noCamerasFound: 'Brak zapisanych kamer',
  noGlobalCameras: 'Brak globalnych kamer',
  allGlobalCamerasInUse:
    'Wszystkie globalne kamery są używane w tej konfiguracji',
  notUsedInFlow: 'Kamera nie używana w konfiguracji',
  otherCameras: 'Inne widoki kamer',
  selectIcon: 'Wybierz ikonę',
  labelLabel: 'Nazwa kamery',
  codeLabel: 'Kod',
  descriptionLabel: 'Opis kamery',
  inactiveCamera: 'Kamera nie aktywna',
  activeCamera: 'Kamera aktywna',
  enableCamera: 'Włącz kamerę',
  disableCamera: 'Wyłącz kamerę',
  cameraActivated: 'Kamera została aktywowana',
  cameraDeactivated: 'Kamera została deaktywowana',
  cameraIsDefault: 'Ta kamera jest domyślna',
  setCameraAsDefault: 'Ustaw jako domyślną',
  unsetDefault: 'Usuń oznaczenie domyślnej',
  cameraSetDefault: 'Kamera została ustawiona jako domyślna',
  cameraRemovedFromDefault: 'Usunięto domyślną kamerę',
  cameraSetAsDefault: 'Kamera została ustawiona jako domyślna dla flow',
  cameraUnsetAsDefault:
    'Kamera została odznaczona jako domyślna. Przypisz inną kamerę jako domyślną lub pozostaw konfigurację bez domyślnej kamery.',
  cameraDetachedFromFlow: 'Kamera została odpięta od flow',
  cameraAttachedToFlow: 'Kamera została przypięta do flow',
  attachToFlow: 'Podłącz do flow',
  detachFromFlow: 'Odłącz od flow',
  duplicateGlobally: 'Duplikuj globalnie',
  duplicateLocally: 'Duplikuj lokalnie',
  copyToLocal: 'Kopiuj do lokalnych',
  copyToGlobal: 'Kopiuj do globalnych',
  globalScope: 'Globalna',
  localScope: 'Lokalna',
  globalCameraScopeTooltip:
    'Kamera współdzielona. Zmiana wpływa na wszystkie powiązane flow.',
  localCameraScopeTooltip: 'Kamera lokalna tylko dla bieżącego flow.',
  editGlobalCameraTitle: 'Edycja globalnej kamery',
  editGlobalCameraDescription:
    'Zmiana wpłynie na wszystkie konfiguracje. Czy na pewno chcesz kontynuować?',
  deleteGlobalCameraTitle: 'Usuwanie globalnej kamery',
  deleteGlobalCameraDescription:
    'Globalna kamera może zostać usunięta tylko wtedy, gdy nie jest używana w opublikowanym flow.',
  globalCameraNotEditable:
    'Ta globalna kamera jest używana w już opublikowanych konfiguracjach i nie można jej edytować.',
  globalCameraNotDeactivatable:
    'Ta globalna kamera jest używana w już opublikowanych konfiguracjach i nie można jej dezaktywować.',
  globalCameraNotDeletable:
    'Ta globalna kamera jest używana w już opublikowanych konfiguracjach i nie można jej usunąć.',
  onlyLocalCamerasCanBeDefault:
    'Tylko lokalne kamery mogą być ustawione jako domyślne dla flow.',
  saveCameraBeforeDefault:
    'Najpierw zapisz kamerę, aby móc ustawić ją jako domyślną.',
  saveCameraBeforeCopy: 'Najpierw zapisz kamerę, aby móc ją skopiować.',
  saveCameraBeforeAssign:
    'Najpierw zapisz kamerę, aby móc ją przypisać / odpisać.',
  cannotEditDisabled:
    'Nie można edytować wyłączonej kamery. Włącz ją, aby móc edytować.',
  cannotSetDisabledAsDefault:
    'Nie można ustawić wyłączonej kamery jako domyślnej. Włącz ją, aby móc ustawić jako domyślną.',
}
